import { getPage } from './getPage';

export const getProduct = (products, containerType, data) => {
  const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

  let productHTML = '';
  let numProducts;

  if (!products || !Array.isArray(products) || products.length === 0) {
    return;
  }

  if (containerType === 'ha-product__content') {
    numProducts = 5;
    const randomProducts = [];
    const filteredProducts = window.limitSliderToSix
      ? products.filter((product) => !product.nutrition_facts || product.nutrition_facts.length === 0)
      : products;

    while (randomProducts.length < numProducts && randomProducts.length < filteredProducts.length) {
      const randomIndex = getRandomInt(0, filteredProducts.length - 1);
      const randomProduct = filteredProducts[randomIndex];
      if (!randomProducts.some((product) => product.sku === randomProduct.sku)) {
        randomProducts.push(randomProduct);
      }
    }

    productHTML = randomProducts
      .map(
        (product) => `
      <div class="ha-product__box get_product" data-order-type="${product.sku}">
        <div class="home-product__box-img">
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        </div>
        <span>${product.templates.title}</span>
        <div class="home-product__price home-price__custom">
          ${window.options?.currency ? window.options.currency : '$'}${product.price.toFixed(2)}
          ${
            product.templates.retail > 0
              ? `<span>${window.options?.currency ? window.options.currency : '$'}${product.templates.retail}</span>`
              : ''
          }
        </div>
        <div class="home-product__hover hover-custom">+ View Product</div>
      </div>
    `
      )
      .join('');
  } else if (containerType === 'home-product__content') {
    numProducts = products.length;
    let initialCount = 6;
    productHTML = products
      .map(
        (product, index) => `
      <div class="home-product__box get_product ${index >= initialCount ? 'hidden-product' : ''}" 
           data-order-type="${product.sku}" data-index="${index}">
        <div class="home-product__box-img">
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        </div>
        <span>${product.templates.title}</span>
        <div class="home-product__price">
          ${window.options?.currency ? window.options.currency : '$'}${product.price.toFixed(2)}
          ${
            product.templates.retail > 0
              ? `<span>${window.options?.currency ? window.options.currency : '$'}${product.templates.retail}</span>`
              : ''
          }
        </div>
        <div class="home-product__hover">+ View Product</div>
      </div>
    `
      )
      .join('');
    productHTML += '<button id="loadMore" class="load-more-btn">Load More</button>';
  } else if (containerType === 'product-list') {
    productHTML = products
      .map(
        (product) => `
       ${product.templates.title} <br>
       ${product.templates.title.toUpperCase()} BOTTLE - ${
          window.options?.currency ? window.options.currency : '$'
        }${product.price.toFixed(2)}<br> <br>
    `
      )
      .join('');
  } else if (containerType === 'ap-content') {
    productHTML = products
      .map(
        (product) => `
      <div class="ap-item get_product" data-order-type="${product.sku}">
        <div class="ap-item__img">
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        </div>
        <div class="ap-item__name">${product.templates.title}</div>
        <div class="ap-item__price">${window.options?.currency ? window.options.currency : '$'}${product.price.toFixed(
          2
        )}</div>
      </div>
    `
      )
      .join('');
  } else if (containerType === 'banner-flex') {
    let filteredProducts = window.limitSliderToSix
      ? products.filter((product) => !product.nutrition_facts || product.nutrition_facts.length === 0)
      : products;

    const targetCount = Math.min(3, filteredProducts.length);
    const randomProducts = [];
    while (randomProducts.length < targetCount) {
      const randomIndex = getRandomInt(0, filteredProducts.length - 1);
      const randomProduct = filteredProducts[randomIndex];
      if (!randomProducts.some((p) => p.sku === randomProduct.sku)) randomProducts.push(randomProduct);
    }
    productHTML = randomProducts
      .map(
        (product) => `
      <div class="banner-box">
        <div class="banner-box__name">${product.templates.title}</div>
        <div class="banner-box__desc">${product.description}</div>
        <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        <div class="banner-box__button get_product" data-order-type="${product.sku}">Discover Now</div>
      </div>
    `
      )
      .join('');
  } else if (containerType === 'home-flex') {
    productHTML = products
      .map(
        (product) => `
      <div class="home-flex-itm">
        <div class="home-flex-itm-left">
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        </div>
        <div class="home-flex-itm-right">
          <h2 class='headerTitle'></h2>
          <a data-page="shop" class="get_page home-button button">Check the store</a>
        </div>
      </div>
    `
      )
      .join('');
  } else if (containerType === 'home-flex-custom') {
    productHTML = products
      .map(
        (product) => `
      <div class="home-flex-itm-custom get_product" data-order-type="${product.sku}">
        <div class="home-flex-itm-left">
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        </div>
        <div class="home-flex-itm-right-custom">
        <div class="rating-block">
        <div class="stars">
          <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
        </div>
        <span class="reviews-count">463 reviews</span>
      </div>
          <h2 class="headerTitle-custom">${product.templates.title}</h2>
          <div class="home-product__description">
           <p>Health, Every Day!</p>
          </div>
          <a data-page="shop" class="get_page home-button-custom button">Check the store</a>
        </div>
      </div>
    `
      )
      .join('');
  }

  const $container = $(`.${containerType}`);

  if ($container.length > 0) {
    $container.html(productHTML);

    if (containerType === 'home-flex-custom') {
      const bgImages = [
        '/static/common/images/slider/slick-wrapper-1.png',
        '/static/common/images/slider/slick-wrapper-2.png',
        '/static/common/images/slider/slick-wrapper-3.png',
        '/static/common/images/slider/slick-wrapper-4.png',
        '/static/common/images/slider/slick-wrapper-5.png',
        '/static/common/images/slider/slick-wrapper-6.png',
        '/static/common/images/slider/slick-wrapper-7.png',
        '/static/common/images/slider/slick-wrapper-8.png',
        '/static/common/images/slider/slick-wrapper-9.png',
      ];
      bgImages.forEach((src) => {
        const img = new Image();
        img.src = src;
      });
      const updateHeroBg = (index) => {
        const nextImg = bgImages[index % bgImages.length];

        $('.home-hero-custom').css({
          'background-image': `
      linear-gradient(0deg, rgba(50, 50, 50, 0.6), rgba(50, 50, 50, 0.6)), 
      linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), 
      url(${nextImg})
    `,
        });
      };

      updateHeroBg(0);

      $container.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        updateHeroBg(nextSlide);
      });
    }
  }

  $(document)
    .off('click', '.get_product')
    .on('click', '.get_product', function (e) {
      e.preventDefault();
      const sku = $(this).data('order-type');
      if (sku) {
        localStorage.setItem('product', sku);
        window.location.href = `${getPage('product')}&id=${sku}`;
      }
    });

  $(document)
    .off('click', '.get_page')
    .on('click', '.get_page', function (e) {
      e.preventDefault();
      const page = $(this).data('page');
      window.location.href = getPage(page);
    });

  if (data?.templates?.headerTitle) {
    $('.headerTitle').html(data.templates.headerTitle);
  }
};
